import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from '../pages/auth/login_page';
import { Cart } from '../pages/cart/cart';
import { HomePage } from '../pages/home/home';
import { ProductDetail } from '../pages/product/product_detail';
import { CategoryProductsPage } from '../pages/product/category_products_page';
import { SearchProductsPage } from '../pages/product/search_products_page';
import AddressSelectPage from '../pages/orders/addreess_select_page';
import { ProtectedRoute } from '../shared/components/common/protected_route';
import { OrderReviewPage } from '../pages/orders/order_review_page';
import { OrderPlacedPage } from '../pages/orders/order_placed_page';
import { PastOrdersPage } from '../pages/orders/past_orders_page';
import { LoginMerchantPage } from '../pages/auth/login_merchant_page';
import { OrderDetailsPage } from '../pages/orders/order_details_page';

const PrimaryRouter = () => {
  return (
    <Routes>
      <Route path={`/:storeSlug`}>
        <Route path="" element={<HomePage />} />
        <Route path="login" element={<LoginPage />} />
        <Route path="loginViaMerchant" element={<LoginMerchantPage />} />
        <Route path="product">
          <Route path={`:productId`} element={<ProductDetail />} />
        </Route>
        <Route path="category">
          <Route path={`:categoryId`} element={<CategoryProductsPage />} />
        </Route>
        <Route path="search" element={<SearchProductsPage />} />
        <Route path="cart" element={<Cart />} />
        <Route
          path={`orders`}
          element={
            <ProtectedRoute>
              <PastOrdersPage />
            </ProtectedRoute>
          }
        />
        <Route
            path={`orders/:orderId`}
            element={
              <ProtectedRoute>
                <OrderDetailsPage />
              </ProtectedRoute>
            }
          />
        <Route path="buy">
          <Route
            path={`addressselect`}
            element={
              <ProtectedRoute>
                <AddressSelectPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`review`}
            element={
              <ProtectedRoute>
                <OrderReviewPage />
              </ProtectedRoute>
            }
          />
          <Route
            path={`orderplaced/:orderId`}
            element={
              <ProtectedRoute>
                <OrderPlacedPage />
              </ProtectedRoute>
            }
          />
        </Route>
      </Route>
      <Route path="/" element={<RedirectToYufinComponent />}></Route>
    </Routes>
  );
};

const RedirectToYufinComponent = () => {
  window.location.href = 'https://www.yufin.ph';
  return <></>;
};
export default PrimaryRouter;
